import { CSSProperties, PropsWithChildren } from "react"
import { classNames } from "../../style/common";


export type BadgeProps = {
    className?: string | undefined,
    style?: CSSProperties | undefined,
    color?: BadgeColor,
    title?: string
} & PropsWithChildren;

type BadgeColor = "success" | "default" | "theme";
const styles: Record<BadgeColor, string> = {
    "success": "bg-green-200 text-green-700 ring-green-600/20",
    "default": "bg-gray-100 text-gray-600 ring-gray-500/10",
    "theme": "bg-contrast-secondary text-secondary ring-color-border/60"
}



export default function Badge(props: BadgeProps) {
    const colorStyle = props.color ? styles[props.color] : styles["default"];

    return (
        <span
            style={props.style}
            title={props.title}
            className={
                classNames(
                    "inline-flex items-center rounded-full px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset select-none",
                    colorStyle,
                    props.className
                )
            }
        >
            {props.children}
        </span>
    )
}